module.exports = __webpack_public_path__ + "public/adminIcons/Totalusers.svg?c7a880a4";